import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartLine, 
  faBoxes, 
  faHeadset, 
  faCogs,
  faUser,
  faUserPlus
} from '@fortawesome/free-solid-svg-icons';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { useProviders } from '../../../hooks/api/clientsProvides';
import ProviderSidebarStyle from '../../../assets/css/components/client/sidebar/ProviderSidebarStyle';

const ProviderSidebar = () => {
  const location = useLocation();
  const globalContext = useContext(GlobalContext);
  const { providersDashboardData } = useProviders();

  const menuItems = [
    {
      icon: faChartLine,
      label: 'Dashboard de Inventario',
      path: '/admin/client/dashboard',
      description: 'Vista general de su inventario y métricas'
    },
    {
      icon: faBoxes,
      label: 'Detalles por Producto',
      path: '/admin/client/product-details',
      description: 'Análisis detallado de cada producto'
    },
    {
      icon: faCogs,
      label: 'Administración de Productos',
      path: '/admin/client/product-management',
      description: 'Gestión completa de productos',
    },
    {
      icon: faCogs,
      label: 'Productos enviados',
      path: '/admin/client/products-sents',
      description: 'Productos enviados a clientes',
    },
    {
      icon: faUser,
      label: 'Mi Perfil',
      path: '/admin/client/profile',
      description: 'Ver y editar información del perfil',
    }
  ];

  const isActiveRoute = (path) => {
    return location.pathname.startsWith(path);
  };

  const openWhatsApp = () => {
    const phoneNumber = "584241693253";
    const message = encodeURIComponent(`Hola, necesito ayuda con mi dashboard de inventario. Proveedor: ${providersDashboardData?.ownerName || 'No especificado'}`);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleMenuClick = () => {
    // Cerrar sidebar en mobile
    if (globalContext.setStatusMenu) {
      globalContext.setStatusMenu(false);
    }
  };

  return (
    <ProviderSidebarStyle.Container>
      <ProviderSidebarStyle.Header>
        <ProviderSidebarStyle.Logo>
          <ProviderSidebarStyle.LogoIcon>
            <FontAwesomeIcon icon={faBoxes} />
          </ProviderSidebarStyle.LogoIcon>
          <ProviderSidebarStyle.LogoText>
            <span className="brand">E-kommers</span>
            <span className="role">Panel de Proveedor</span>
          </ProviderSidebarStyle.LogoText>
        </ProviderSidebarStyle.Logo>
        
        {providersDashboardData && (
          <ProviderSidebarStyle.ProviderInfo>
            <ProviderSidebarStyle.ProviderName>
              {providersDashboardData.ownerName}
            </ProviderSidebarStyle.ProviderName>
            <ProviderSidebarStyle.ProviderStatus>
              Proveedor Activo
            </ProviderSidebarStyle.ProviderStatus>
          </ProviderSidebarStyle.ProviderInfo>
        )}
      </ProviderSidebarStyle.Header>

      <ProviderSidebarStyle.Navigation>
        <ProviderSidebarStyle.NavTitle>Navegación</ProviderSidebarStyle.NavTitle>
        
        {menuItems.map((item, index) => {
          const isActive = isActiveRoute(item.path);
          const isDisabled = item.disabled;

          if (isDisabled) {
            return (
              <ProviderSidebarStyle.NavItem 
                key={index}
                active={false}
                disabled={true}
                data-active="false"
              >
                <ProviderSidebarStyle.NavIcon active={false}>
                  <FontAwesomeIcon icon={item.icon} />
                </ProviderSidebarStyle.NavIcon>
                <ProviderSidebarStyle.NavContent>
                  <ProviderSidebarStyle.NavLabel>
                    {item.label}
                  </ProviderSidebarStyle.NavLabel>
                  <ProviderSidebarStyle.NavDescription>
                    {item.description}
                  </ProviderSidebarStyle.NavDescription>
                </ProviderSidebarStyle.NavContent>
                <ProviderSidebarStyle.ComingSoon>
                  Próximamente
                </ProviderSidebarStyle.ComingSoon>
              </ProviderSidebarStyle.NavItem>
            );
          }

          return (
            <Link 
              key={index}
              to={item.path} 
              style={{ textDecoration: 'none' }}
              onClick={handleMenuClick}
            >
              <ProviderSidebarStyle.NavItem 
                active={isActive}
                disabled={false}
                data-active={isActive ? "true" : "false"}
              >
                <ProviderSidebarStyle.NavIcon active={isActive}>
                  <FontAwesomeIcon icon={item.icon} />
                </ProviderSidebarStyle.NavIcon>
                <ProviderSidebarStyle.NavContent>
                  <ProviderSidebarStyle.NavLabel>
                    {item.label}
                  </ProviderSidebarStyle.NavLabel>
                  <ProviderSidebarStyle.NavDescription>
                    {item.description}
                  </ProviderSidebarStyle.NavDescription>
                </ProviderSidebarStyle.NavContent>
                {isActive && (
                  <ProviderSidebarStyle.ActiveIndicator />
                )}
              </ProviderSidebarStyle.NavItem>
            </Link>
          );
        })}
              <ProviderSidebarStyle.Footer>
        <ProviderSidebarStyle.FooterCard>
          <ProviderSidebarStyle.FooterIcon>
            <FontAwesomeIcon icon={faHeadset} />
          </ProviderSidebarStyle.FooterIcon>
          <ProviderSidebarStyle.FooterContent>
            <ProviderSidebarStyle.FooterTitle>
              ¿Necesitas ayuda?
            </ProviderSidebarStyle.FooterTitle>
            <ProviderSidebarStyle.FooterText>
              Nuestro equipo está aquí para apoyarte
            </ProviderSidebarStyle.FooterText>
            <ProviderSidebarStyle.FooterButton onClick={openWhatsApp}>
              Contactar Soporte
            </ProviderSidebarStyle.FooterButton>
          </ProviderSidebarStyle.FooterContent>
        </ProviderSidebarStyle.FooterCard>
      </ProviderSidebarStyle.Footer>
      </ProviderSidebarStyle.Navigation>


    </ProviderSidebarStyle.Container>
  );
};

export default ProviderSidebar; 